import { Vue, Component } from 'vue-property-decorator';
import { appConfigService } from '@/providers/services/app/app-config';
import { authAPI } from '@/providers/apis/auth/auth';
import { appConfigAPI } from '@/providers/apis/app/app-config';
import { sessionService } from '@/providers/services/auth/session';
import { demoUser } from '@/providers/apis/demo-user/demo-user';

@Component({
    name: 'guest',
})

export default class Guest extends Vue {

    // -------------------------------------------------------------------------------------
    // Hooks
    private mounted() {
        this.guestAccount();
    }

    // ---------------------------------------------------------------------------------------
    // Methods

    private guestAccount() {
        const guestAccountDetails: any = appConfigService.guestAccountDetails() || this.getGuestUser();
        authAPI
            .logInWithCredential(guestAccountDetails.username, guestAccountDetails.password, '')
            .then(
                (session) => {
                    appConfigAPI.getAppPermissions(session.permissions).then((userRole: any) => {
                        if (userRole) {
                            appConfigService.setAppUserRole(userRole);
                            sessionService.setSession(session);
                            window.location.href = '/facet-search';
                        }
                    });
                });
    }

    private getGuestUser() {
        return demoUser.getGuestUser().then((data: any) => {
            return data;
        });
    }

}
